// El backend manda las fechas de calendario como "YYYY-MM-DD" y las marcas de
// tiempo como ISO en UTC *sin zona* ("2026-10-25T10:00:00"). new Date() las
// interpretaría mal: la primera como UTC (un día menos al oeste de Greenwich) y
// la segunda como hora local.

// "2026-10-25" -> Date a medianoche local.
export const parseCalendarDate = (value) => {
  if (!value) return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (!match) {
    const fallback = new Date(value);
    return Number.isNaN(fallback.getTime()) ? null : fallback;
  }
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
};

// "2026-10-25T10:00:00" (UTC sin zona) -> Date correcta.
export const parseUtcTimestamp = (value) => {
  if (!value) return null;
  const hasZone = /(Z|[+-]\d{2}:?\d{2})$/.test(value);
  const date = new Date(hasZone ? value : `${value}Z`);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatCalendarDate = (value) => {
  const date = parseCalendarDate(value);
  return date ? date.toLocaleDateString('es-MX') : '—';
};

export const formatTimestamp = (value) => {
  const date = parseUtcTimestamp(value);
  return date ? date.toLocaleString('es-MX') : '—';
};

// --- Hora de México -------------------------------------------------------
// El servidor calcula "hoy" en hora de México (la VPS está en UTC). Las
// pantallas de venta hacen lo mismo para que "hoy" no cambie a las 6 pm del
// centro del país por culpa de la zona horaria del navegador.
const MX_TIMEZONE = 'America/Mexico_City';

const mexicoParts = (date = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: MX_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date);
  const get = (type) => parts.find((p) => p.type === type).value;
  return {
    date: `${get('year')}-${get('month')}-${get('day')}`,
    time: `${get('hour')}:${get('minute')}`,
  };
};

// "YYYY-MM-DD" de hoy en México.
export const todayInMexico = () => mexicoParts().date;

// "HH:MM" de ahora en México.
export const nowTimeInMexico = () => mexicoParts().time;

// "YYYY-MM-DD" desplazado N días (aritmética de calendario, sin zona).
export const shiftCalendarDate = (value, days) => {
  const date = parseCalendarDate(value);
  if (!date) return value;
  date.setDate(date.getDate() + days);
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

// Días entre dos fechas "YYYY-MM-DD" (to - from), inclusivo = +1.
export const daysBetween = (from, to) => {
  const a = parseCalendarDate(from);
  const b = parseCalendarDate(to);
  if (!a || !b) return NaN;
  return Math.round((b - a) / 86400000);
};
